const API_STACK = 'billing/';

export const GET_SUBSCRIPTION_TIER = API_STACK + 'subscription/:providerUuid';
export const PATCH_SUBSCRIPTION_TIER = GET_SUBSCRIPTION_TIER;
export const DELETE_SUBSCRIPTION = GET_SUBSCRIPTION_TIER;
export const GET_OFFER = API_STACK + 'offer/:offerCode';
export const POST_CREATE_SUBSCRIPTION_OPERATION = API_STACK + 'operations/subscription/';
export const POST_PROCESS_REFUND_OPERATION = API_STACK + 'operations/refund/';
export const GET_SUB_UPDATE_DUE_DATA = API_STACK + 'subscription/due/:providerUuid';
export const POST_SUBSCRIPTION_SCHEDULE = API_STACK + 'subscription/schedule/:providerUuid';
export const GET_INVOICES = API_STACK + 'invoice/:providerUuid';